export enum ChatAgentPermissions {
  ACCESS_CHAT_AGENT = 'chatAgent.accessChatAgent',
  ACCESS_GRAPHQL_MCP = 'chatAgent.accessGraphQLMCP',
}
